import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';
import { IVideoProps } from 'tbk-components/src/components/Video';
import AdvancedMedia from '../AdvancedMedia';
import Icon from 'tbk-components/src/components/Icon';

export interface IFeaturedProjectProps extends IBaseElementProps {
	title?: string;
	subtitle?: string;
	cta?: ILink;
	image?: IImage;
	video?: IVideoProps;
	logo?: IImage;
	hoverStyle?: 'Default' | 'Tile' | 'Arrow';
}

const FeaturedProject: React.FC<IFeaturedProjectProps> = ({
	className,
	classNames = [],
	title,
	cta,
	subtitle,
	image,
	video,
	logo,
	hoverStyle = 'Default',
}) => {
	const renderedHoverStyle =
		hoverStyle !== 'Default' ? hoverStyle : !video?.url ? 'Tile' : 'Arrow';

	const hoverRender = (
		<div className="featured-project-tile__hover-render position-absolute w-100 h-100 top-0 start-0 z-3 d-flex flex-column align-items-center justify-content-center">
			{renderedHoverStyle == 'Tile' && (
				<div className="image-hover my-auto d-none d-md-block mw-70 w-100 bg-light rounded-5 px-3 py-8 d-flex align-items-center justify-content-center">
					<div className="image-hover-copy text-center">
						{logo && (
							<Image
								{...logo}
								className="mb-3 w-100 h-auto mw-85px"
							/>
						)}
						{title && <h3 className="mb-0">{title}</h3>}
						{subtitle && (
							<p className="subheading mt-2 mb-0">{subtitle}</p>
						)}
						{cta?.label && (
							<span className="btn btn-sm btn-primary mt-4">
								{cta?.label}
							</span>
						)}
					</div>
				</div>
			)}
			<div className="arrow-hover mt-auto h4 mb-4 text-white mx-auto align-self-end justify-self-end">
				<Icon name="arrow-right"></Icon>
			</div>
		</div>
	);
	const core = (
		<>
			<div className="featured-project-tile__header mw-400px top-0 position-absolute z-2 w-100 mx-auto h-100 text-center text-white d-flex flex-column align-items-center justify-content-center">
				{title && <h3 className="mb-0 text-white">{title}</h3>}
				{subtitle && (
					<p className="mb-0 subheading text-white">{subtitle}</p>
				)}
			</div>
			<div
				className={cn(
					`featured-project-tile__overlay top-0 start-0 bg-primary position-absolute z-1 h-100 w-100`,
					renderedHoverStyle == 'Tile' && 'image-scene',
				)}
			></div>
		</>
	);
	return (
		<div
			className={cn(
				`featured-project-tile`,
				className || [
					`position-relative w-100 h-auto d-block`,
					...classNames,
				],
			)}
		>
			{cta?.href ? (
				<a
					href={cta.href}
					className="featured-project-tile--link d-flex justify-content-center w-100 h-100"
					aria-label={`${cta?.label} ${title}`}
					title={`${cta?.label} ${title}`}
				>
					{hoverRender}
					{core}
					<AdvancedMedia
						image={image}
						className="w-100 h-100"
						size="4:3"
						video={video}
					></AdvancedMedia>
				</a>
			) : (
				core
			)}
		</div>
	);
};

export default FeaturedProject;
